<template>
  <div class="label-row">
    <div class="label" :style="{ width: labelWidth }">{{ label }}</div>
    <div><slot></slot></div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'
// eslint-disable-next-line
const props = defineProps({
  label: String,
  labelWidth: {
    type: String
  }
})

const { label, labelWidth } = toRefs(props)
</script>

<style lang="scss" scoped>
.label-row {
  display: flex;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .label {
    font-weight: 700;
  }
}
</style>
